import React from 'react';
import { Button, Divider, HStack, Image, Stack, Text } from '@chakra-ui/react';
import icones from '~/assets/evaluate-icons.svg';
import { Textarea } from '~/components';
import { NextStep } from '~/pages/Portal/TechnicalSupport/index';
import { DarkenColor } from '~/utils/colors';

interface EvaluateServiceProps {
  type?:
    | 'open-ticket'
    | 'open-baterry'
    | 'canceled'
    | 'out-of-scope'
    | 'open-missing-material'
    | 'open-misuse'
    | 'open-misapplication'
    | 'release-update'
    | 'open-complaint'
    | 'success-flow'
    | 'photo-request';
  onChange: (avaliacao: number, texto: string, step: NextStep) => void;
  passos: NextStep;
}
export const EvaluateService: React.VFC<EvaluateServiceProps> = ({
  passos,
  type,
  onChange,
}) => {
  const [sucesso, setSucesso] = React.useState<boolean>(false);
  const parametroAvaliacao = [
    { id: 0, cor: '#d06144', selecionado: false },
    { id: 1, cor: '#d47445', selecionado: false },
    { id: 2, cor: '#e0a952', selecionado: false },
    { id: 3, cor: '#e6be5b', selecionado: false },
    { id: 4, cor: '#efd865', selecionado: false },
    { id: 5, cor: '#f7ef6f', selecionado: false },
    { id: 6, cor: '#d3ea6a', selecionado: false },
    { id: 7, cor: '#c3e668', selecionado: false },
    { id: 8, cor: '#b0e26a', selecionado: false },
    { id: 9, cor: '#a5d36e', selecionado: false },
    { id: 10, cor: '#96ca5b', selecionado: false },
  ];
  const [listaAvaliacao, setListaAvaliacao] =
    React.useState<any[]>(parametroAvaliacao);
  const [textoAvaliacao, setTextoAvaliacao] = React.useState<string>('');
  const [qtdCatacteres, setQtdCaracteres] = React.useState<number>(0);
  const [avaliacao, setAvaliacao] = React.useState<number>(0);
  const changeTextoAvaliacao = (texto: string) => {
    if (texto.length > 250) return;
    setTextoAvaliacao(texto);
    setQtdCaracteres(texto.length);
  };

  const mudarSelecionado = (id: number) => {
    const auxLista = listaAvaliacao.map(item => {
      const newItem = { ...item };

      newItem.selecionado = false;

      if (newItem.id === id) {
        newItem.selecionado = true;
      }

      return newItem;
    });
    setListaAvaliacao(auxLista);
  };

  const existeItemSelecionado = () => {
    const itemSelecionado = listaAvaliacao.find(item => item.selecionado);
    return itemSelecionado;
  };

  const textAreaLabel = () => {
    const itemSelecionado = listaAvaliacao.find(item => item.selecionado);
    if (itemSelecionado?.id === 10) {
      return 'Em poucas palavras, descreva o que motivou a sua nota (opcional)';
    }
    return 'Em poucas palavras, o que podemos fazer para ganhar um 10? (opcional)';
  };

  const typeFlow = () => {
    if (type === undefined) {
      return (
        <Text textAlign="center" fontSize="16px">
          Ops, você decidiu encerrar o atendimento. Não há problema algum.
          Esperamos poder ajudá-lo em um momento futuro.
        </Text>
      );
    }
    if (type === 'success-flow') {
      return (
        <Text textAlign="center" fontSize="16px">
          Que bom que pudemos ajudar!
        </Text>
      );
    }
    return (
      <Stack alignItems="center" gridGap={2}>
        <Text fontSize="16px" textAlign="center">
          Que pena! Fiz tudo que eu podia para te ajudar por aqui, mas não
          consegui resolver. Você precisa entrar em contato com um dos nossos
          técnicos para continuar o atendimento.
        </Text>
        <Button
          as="a"
          variant="outline"
          maxW="fit-content"
          href="https://servicos.meupositivo.com.br/suporte/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Canais de atendimento
        </Button>
      </Stack>
    );
  };

  return (
    <Stack divider={<Divider />} alignItems="center" margin="0px !important">
      <Stack justifyContent="center" width="650px" p={3}>
        {typeFlow()}
      </Stack>
      <Stack justifyContent="center" width="550px" p={3}>
        <Text fontSize="16px">
          Antes de finalizar, avalie nosso atendimento. Sua opinião é importante
          para nós!!
        </Text>
        <Text paddingTop={4} fontSize="16px">
          Quanto você ficou satisfeito com este canal de atendimento?
        </Text>
        <HStack justifyContent="space-between" paddingTop={4}>
          <Text fontSize="small">Completamente insatisfeito</Text>
          <Text fontSize="small">Completamente satisfeito</Text>
        </HStack>
        <HStack>
          {listaAvaliacao.map((item, index) => {
            return (
              <Stack
                cursor="pointer"
                margin="0px !important"
                key={item.id}
                width="50px"
                height="50px"
                backgroundColor={item.cor}
                justifyContent="center"
                alignItems="center"
                onClick={() => {
                  mudarSelecionado(item.id);
                  setAvaliacao(item.id);
                }}
                background={item.selecionado ? DarkenColor(item.cor, 0.2) : ''}
              >
                <Text
                  fontSize={item.selecionado ? 'medium' : 'small'}
                  fontWeight="bold"
                  color="black"
                >
                  {item.id}
                </Text>
              </Stack>
            );
          })}
        </HStack>
        <Stack alignItems="center" width="100%" paddingTop={2} gridGap={3}>
          <Image src={icones} />
          {existeItemSelecionado() && (
            <Stack w="100%">
              <Textarea
                label={textAreaLabel()}
                name="texto_avaliacao"
                resize="none"
                fontSize="15px"
                value={textoAvaliacao}
                onChange={e => {
                  changeTextoAvaliacao(e.target.value);
                }}
              />
              <Text fontSize="small" color="gray.500" textAlign="right">
                {qtdCatacteres}/250
              </Text>
            </Stack>
          )}
          <Button
            width="fit-content"
            color="white"
            background="gray.900"
            _hover={{
              bgColor: 'black',
            }}
            onClick={() => {
              const auxStep = {
                ...passos,
                isAvaliacao: true,
                isAvaliacaoEnviada: false,
                isFinalizarAtendimento: false,
              };
              onChange(avaliacao, textoAvaliacao, auxStep);
            }}
            isDisabled={!existeItemSelecionado()}
          >
            Enviar
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
